import { createReducer, on, Action } from '@ngrx/store';
import * as CompanyActions from '../actions/company.actions';
import { Company } from '@app/@core/data/models/company.model';
import { CompanyIntegrations } from '@app/@core/data/models/company-integrations.model';

export interface CompanyState {
  company: Company;
  companyIntegration: CompanyIntegrations | null;
}

export const initialState: CompanyState = {
  company: null,
  companyIntegration: null,
};

const companyReducer = createReducer(
  initialState,
  on(CompanyActions.loadCompany, state => ({
    ...state,
    company: null,
  })),
  on(CompanyActions.loadCompanySuccess, (state, action) => ({
    ...state,
    company: action.payload.company,
  })),
  on(CompanyActions.loadCompanyIntegration, state => ({
    ...state,
    companyIntegration: null,
  })),
  on(CompanyActions.loadCompanyIntegrationSuccess, (state, action) => ({
    ...state,
    companyIntegration: action.payload.companyIntegration,
  })),
);

export function reducer(state: CompanyState | undefined, action: Action) {
  return companyReducer(state, action);
}
